import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MODALS, PERMISSIONS } from '../../../constants';
import { checkPermisson, getActiveModal, getLeagues } from '../../../selectors/common';
import { getPlayersTemplate } from '../../../selectors/teams';
import PlayersTemplate from '..';
import { aGetPlayersTemplateRequest } from '../../../reducers';
import { aSetOpenModal } from '../../../reducers/common';

const mapToProps = (state) => ({
  playersTemplate: getPlayersTemplate(state),
  leagues: getLeagues(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
  activeModal: getActiveModal(state),
});

const actionsToProps = (dispatch) => ({
  getPlayersTemplateRequest: (payload) => dispatch(aGetPlayersTemplateRequest(payload)),
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
});
class SoccerPlayerTemplate extends Component {
  constructor(props) {
    super(props);

    this.hasPermissionTo = {
      add: props.checkPermisson(PERMISSIONS.PLAYER_TEMPLATES_ADD),
      view: props.checkPermisson(PERMISSIONS.PLAYER_TEMPLATES_VIEW),
    };
  }

  componentDidMount() {
    this.props.getPlayersTemplateRequest();
  }

  render() {
    return (

      <PlayersTemplate
        hasPermissionToAdd={this.hasPermissionTo.add}
        hasPermissionToView={this.hasPermissionTo.view}
        leagues={this.props.leagues}
        addModalName={MODALS.PLAYERS_TEMPLATE_ADD}
        playersTemplate={this.props.playersTemplate}
        addBtnLabel="New Teams Template"
      />
    );
  }
}

export default connect(mapToProps, actionsToProps)(SoccerPlayerTemplate);
